<script setup lang="ts">
import { useNotificationStore } from '@/stores/useNotificationStore';
import SvgIcon from '@/components/SvgIcon.vue';

const $notificationStore = useNotificationStore();
</script>

<template>
  <VSnackbar
    :key="$notificationStore.snackbar.key"
    v-model="$notificationStore.isDisplayed"
    :timeout="$notificationStore.snackbar.timeout"
    variant="elevated"
    :color="$notificationStore.snackbar.variant"
  >
    {{ $notificationStore.snackbar.message }}
    <template v-slot:actions>
      <SvgIcon class="cursor-pointer" icon="XMark" @click="$notificationStore.closeSnackbar"> Close </SvgIcon>
    </template>
  </VSnackbar>
</template>
